import { Timestamp } from '@angular/fire/firestore';
import { IClubMember, IClubState, INIT_CLUB_STATE } from '@soposopo/sopo-models';

export interface ClubState {
    id: string;
    activeComponent: ClubComponent;
    clubData: IClubState;
    membersState: MembersState;
    lastReadMessageId: string;
    messages: ClubMessage[];
    listening: boolean;
}

export interface MembersState {
    numberOfMembers: number;
    listening: boolean;
    members: IClubMember[];
}

export const MEMBERS_INIT_STATE: MembersState = {
    numberOfMembers: 0,
    listening: false,
    members: [],
}

export interface ClubComponent {
    componentId: ClubComponentId;
    metadata?: ClubComponentMetadata;
}

export const CLUB_COMPONENT_INIT: ClubComponent = {
    componentId: 'games',
}

export type ClubComponentId =
    'counter' | 'games' | 'members' | 'requests' |
    'ended_tournaments' | 'reports' | 'settings' | 'trade_record' |
    'club_card' | "club_invitation" | 'player_profit_loss' | 'reconcile_profit' | 'profit_burn' | 'club_chat';

export interface ClubComponentMetadata {
    memberId?: string;
    activatedFromMembersList?: boolean;
}

export const CLUB_INIT_STATE: ClubState = {
    id: 'SOPO',
    activeComponent: {...CLUB_COMPONENT_INIT},
    clubData: {...INIT_CLUB_STATE},
    membersState: {...MEMBERS_INIT_STATE},
    lastReadMessageId: '',
    messages: [],
    listening: false,
};

export interface ClubMessage extends ChatMessage {};

export interface ChatMessage {
    text: string;
    dateCreated: Timestamp;
    messageID: string;
    senderID: string;
    senderName: string;
    senderPic: string;
};
